export class FeatureClassificationFactory {
    static create(featureClassification: IFeatureClassification): IContentAPIFeatureClassification {
        return new FeatureClassification(featureClassification).serialize();
    }
}

export class FeatureClassification {
    protected _baseFeatureType: BaseFeatureType;

    // DEPRECATED properties - kept for backward compatibility
    protected _characteristics?: IFeatureCharacteristics;
    protected _characteristicCodes?: Array<string>;

    // NEW properties
    protected _crossCatalog?: boolean;
    protected _subType?: IFeatureClassificationSubType;
    protected _affectedCharacteristics?: Array<string>;
    protected _value?: DimensionFeatureValues | PositioningFeatureValues | OpeningFeatureValues;

    protected _tags?: Array<string>;

    constructor(featureClassification: IFeatureClassification) {
        this._baseFeatureType = featureClassification.baseFeatureType;

        // DEPRECATED - but still supported for backward compatibility
        this._characteristics = featureClassification.characteristics;
        this._characteristicCodes = featureClassification.characteristicCodes;

        // NEW properties
        this._crossCatalog = featureClassification.crossCatalog;
        this._subType = featureClassification.subType;
        this._affectedCharacteristics = featureClassification.affectedCharacteristics;
        this._value = featureClassification.value;

        this._tags = featureClassification.tags;
    }

    serialize(): IContentAPIFeatureClassification {
        const featureClassification: IContentAPIFeatureClassification = {
            baseFeatureType: this._baseFeatureType
        };

        // DEPRECATED - but MUST be serialized for backward compatibility
        if (this._characteristics !== undefined) {
            featureClassification.characteristics = this._characteristics;
        }

        if (this._characteristicCodes !== undefined) {
            featureClassification.characteristicCodes = this._characteristicCodes;
        }

        // NEW properties
        if (this._crossCatalog !== undefined) {
            featureClassification.crossCatalog = this._crossCatalog;
        }

        if (this._subType !== undefined) {
            featureClassification.subType = this._subType;
        }

        if (this._affectedCharacteristics !== undefined) {
            featureClassification.affectedCharacteristics = this._affectedCharacteristics;
        }

        if (this._value !== undefined) {
            featureClassification.value = this._value;
        }

        if (this._tags !== undefined) {
            featureClassification.tags = this._tags;
        }

        return featureClassification;
    }
}

export interface IContentAPIFeatureClassification {
    baseFeatureType: BaseFeatureType;

    // DEPRECATED properties - kept for backward compatibility
    characteristics?: IFeatureCharacteristics;
    characteristicCodes?: Array<string>;

    // NEW properties
    crossCatalog?: boolean;
    subType?: IFeatureClassificationSubType;
    affectedCharacteristics?: Array<string>;
    value?: DimensionFeatureValues | PositioningFeatureValues | OpeningFeatureValues;

    tags?: Array<string>;
}